module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fmcDX"))).then(() => parcelRequire('1iHdE'));